import React, { useState, useEffect } from 'react';
import { FormControlLabel, MenuItem, Select, Switch } from '@mui/material';
import { useMutation, useQueryClient } from "@tanstack/react-query";
import SoftBox from 'components/SoftBox';
import { useAgencyInfo } from "context/agency";
import useRequest from "hook/useRequest";
import { ReqMethods } from "enums";
import { useUpdateAccount, accountKeys } from "queries/accounts";
import { loadStripe } from "@stripe/stripe-js";

const { GET, PUT } = ReqMethods;

function SaasTab({ saasdatda, formData, agencySaas, handleRefresh }) {
    const request = useRequest();
    const queryClient = useQueryClient();
    const [toggleChecked, setToggleChecked] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [error, seterror] = useState('');
    const [searchResults, setSearchResults] = useState([]);
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [selectedPlan, setSelectedPlan] = useState(null);
    const [isSearching, setIsSearching] = useState(false);
    const [agency] = useAgencyInfo();
    let stripe;
    loadStripe(agency?.stripe?.publish_key).then((stripeInstance) => {
        stripe = stripeInstance;
    });

    useEffect(() => {
        if (formData?.type === 'premium') {
            setToggleChecked(true);
        } else {

            setToggleChecked(false);
        }
    }, [saasdatda]);

    // const handleToggleChange = (event) => {
    //     if (!toggleChecked && event.target.checked) {
    //         // setOpenModal(true);
    //         setSearchQuery('');
    //         seterror('');

    //     } else {
    //         setopensaasModaloff(true)

    //     }
    // };

    const handleModalClose = (confirmed) => {
        setOpenModal(false);
        setSelectedCustomer('')
        setSearchQuery('');
        if (confirmed) {
            setToggleChecked(true);
        }
    };

    const { mutateAsync: updateAccountMutation } = useUpdateAccount();

    const handleEnableSaas = async () => {
        if (!selectedCustomer?.id) {
            seterror("Customer not found ..!")
            return false;
        }
        const payload = {
            _id: formData?.id,
            type: 'premium',
            plan_id: selectedPlan,
            customer_id: selectedCustomer?.id,
            phone_number: selectedCustomer?.phone
        }

        const { response } = await updateAccountMutation(payload);
        if (response) {
            setToggleChecked(true);
            setOpenModal(false);
        };
    }

    const handleSearchChange = async (event) => {
        setIsSearching(true)
        const query = event.target.value;
        setSearchQuery(query);

        if (query.length > 2) {
            try {
                // agency.* - not covered by an existing hook in queries/agency.js
                // (owned by another fork), so inlined directly via useRequest().
                const { response } = await request(GET, "/agency/find-customers", {
                    query: `q=${query}&agency_id=${agency?._id}`,
                });
                if (response) {
                    setSearchResults(response.data);
                    setIsSearching(false);
                    seterror("")
                }
            } catch (error) {

                console.error('Error searching customers:', error);
                setIsSearching(false);
            }
        } else {
            setIsSearching(false);
            setSearchResults([]);

        }
    };

    const handleCustomerSelect = (customer) => {
        setSelectedCustomer(customer);
        setSearchResults([]);
        setSearchQuery(customer.email);
    };
    // const handleupdateaccount_tyoe_to_Free = async () => {

    //     const payload = {
    //         _id: formData?.id,
    //         type: 'free',
    //         plan_id: null,
    //     }

    //     const { response } = await updateAccountMutation(payload);
    //     if (response) {
    //         setToggleChecked(false);
    //         setopensaasModaloff(false);
    //         handleRefresh()
    //     };
    // }

    // Inlined rather than queries/subscriptions.js's usePaymentInfoByAgencyId /
    // useUpgradeSubscription - this orchestrates a GET (payment-method check)
    // then a PUT with conditional Stripe confirmation, which doesn't fit either
    // hook's shape (a reactive query, and a plain single-call mutation).
    const { mutateAsync: upgradeSubscriptionMutation } = useMutation({
        mutationFn: async (planObj) => {
            // Get payment info for the agency/customer
            const { response } = await request(
                GET,
                `/subscriptions/agency/${agency?._id}/${formData?.customer_id}`,
                {},
            );
            if (!response?.data?.id) {
                throw new Error("Payment method not found.");
            }
            const payload = {
                agency_id: agency?._id,
                subscription_id: formData?.subscription_id,
                price_id: planObj?.monthly_id,
                account_id: formData?._id,
                plan_id: planObj?._id,
                paymentMethod_id: response?.data?.id,
                customer_id: formData?.customer_id,
                subscription_type: 'upgrade',
            };
            const updatedResponse = await request(PUT, "/subscriptions/upgrade-subscription", {
                payload,
            });
            if (updatedResponse?.error?.message?.includes('incomplete')) {
                const subscription = updatedResponse?.error?.data;
                const latestInvoice = subscription.latest_invoice;
                const paymentIntent = latestInvoice?.payment_intent;
                if (
                    paymentIntent &&
                    (paymentIntent.status === "requires_action" ||
                        paymentIntent.status === "requires_confirmation")
                ) {
                    const { error: confirmError } = await stripe.confirmCardPayment(
                        paymentIntent.client_secret
                    );

                    if (confirmError) {
                        throw new Error(confirmError?.message || "Failed to upgrade subscription.");
                    }
                }
            } else if (updatedResponse?.error) {
                throw new Error(updatedResponse?.error?.message || "Failed to upgrade subscription.");
            }
            return updatedResponse;
        },
        onSuccess: () => queryClient.invalidateQueries({ queryKey: accountKeys.all }),
    });

    const handleUpgradeSubscription = async () => {
        setLoading(true);
        if (!selectedPlan) {
            alert("Please select a plan to upgrade.");
            setLoading(false);
            return;
        }
        // Find selected plan object
        const planObj = agencySaas?.find(item => item?._id === selectedPlan);
        if (!planObj) {
            alert("Selected plan not found.");
            setLoading(false);
            return;
        }
        try {
            await upgradeSubscriptionMutation(planObj);
            alert("Subscription upgraded successfully.");
        } catch (err) {
            alert(err?.message || "Failed to upgrade subscription.");
            console.error(err);
        }
        setLoading(false);
    };

    return (
        <div>
            <div style={{ position: "absolute", top: "28px", right: "48px" }}>
                <FormControlLabel
                    control={
                        <Switch
                            checked={toggleChecked}
                            // onChange={handleToggleChange}
                            disabled={formData?.account_type === 'premium'}
                            style={{
                                '&:hover': {
                                    cursor: formData?.account_type !== 'premium' ? 'not-allowed' : 'pointer',
                                },
                            }}
                        />
                    }
                    label=""
                />
            </div>

            {toggleChecked && (
                <>
                    <div style={{ display: "flex", margin: "10px" }}>
                        <div style={{ width: "30%", padding: "10px 10px 0px 10px" }}>
                            <SoftBox style={{ margin: "10px 0px " }}>
                                <label className='text-black'>Plan Name</label>
                                <input readOnly className='form-control-agust' type="text" value={saasdatda?.product_name} />
                            </SoftBox>
                        </div>
                        <div style={{ width: "30%", padding: "10px 10px 0px 10px" }}>
                            <SoftBox style={{ margin: "10px 0px " }}>
                                <label className='text-black'>Markup Margin</label>
                                <input readOnly className='form-control-agust' type="text" value={saasdatda?.rebilling?.markupmargin} />
                            </SoftBox>
                        </div>
                        <div style={{ width: "30%", padding: "10px 10px 0px 10px" }}>
                            <SoftBox style={{ margin: "10px 0px " }}>
                                <label className='text-black'>User limit</label>
                                <input readOnly className='form-control-agust' type="number" value={saasdatda?.user_limit} />
                            </SoftBox>
                        </div>
                    </div>
                    <div style={{ display: "flex", margin: "10px" }}>
                        <div style={{ width: "30%", padding: "10px 10px 0px 10px" }}>
                            <SoftBox style={{ margin: "10px 0px " }}>
                                <label className='text-black'>Stripe Customer ID</label>
                                <input readOnly className='form-control-agust' type="text" value={formData?.customer_id != '' ? formData?.customer_id : formData?.stripe_cst_id} />
                            </SoftBox>
                        </div>
                        <div style={{ width: "30%", padding: "10px 10px 0px 10px" }}>
                            <SoftBox style={{ margin: "10px 0px " }}>
                                <label className='text-black'>Subscription ID</label>
                                <input readOnly className='form-control-agust' type="text" value={formData?.subscription_id} />
                            </SoftBox>
                        </div>

                        <div style={{ width: "30%", padding: "10px 10px 0px 10px" }}>
                            <SoftBox style={{ margin: "10px 0px " }}>
                                <label className='text-black'>Change Plan</label>
                                <select
                                    labelId="dropdown-label"
                                    value={selectedPlan || ''}
                                    label="Change Plan"
                                    onChange={e => setSelectedPlan(e.target.value)}
                                    className='form-control-agust'
                                    style={{ padding: "16px" }}
                                >
                                    <option value='' disabled>Select Plan</option>
                                    {agencySaas?.map((item, index) => (
                                        <option value={item?._id} key={index}>{item?.product_name}</option>
                                    ))}
                                </select>
                                <button
                                    className='savebtn-setting w-100'
                                    style={{ marginTop: "12px", width: "fit-content" }}
                                    onClick={handleUpgradeSubscription}
                                    disabled={!selectedPlan || loading}
                                >
                                    {loading ? 'Updating Plan...' : 'Update Plan'}
                                </button>
                            </SoftBox>
                        </div>
                    </div>
                </>
            )}

            {/* {openModal && (
                <div className="modal-zz-confirm text-left">
                    <div className="scrollable-modal-content bg-white rounded" style={{ position: "relative" }}>
                        <h2 className='text-black text-left font-14'>Select Customer</h2>
                        <span className='crossison' onClick={() => handleModalClose(false)}>X</span>
                        <div style={{ position: 'relative' }}>
                            <input
                                type="text"
                                value={searchQuery}
                                onChange={handleSearchChange}
                                placeholder="Search customer by name or email"
                                style={{
                                    width: "100%",
                                    borderRadius: "6px",
                                    border: "1px solid #ccc",
                                    textIndent: "10px",
                                    marginTop: "10px",
                                }}
                                required={true}
                            />
                            {isSearching && (
                                <div class="spinner spinnerAbsolute"></div>
                            )}
                        </div>
                        {searchResults.length > 0 ? (
                            <div style={{
                                position: "absolute",
                                left: "4%",
                                width: "92%",
                                backgroundColor: "white",
                                border: "1px solid #ccc",
                                borderRadius: "6px",
                                maxHeight: "200px",
                                overflowY: "auto",
                                zIndex: 1000,
                                marginTop: "5px"
                            }}>
                                {searchResults.map((customer) => (
                                    <div
                                        key={customer.id}
                                        onClick={() => handleCustomerSelect(customer)}
                                        style={{
                                            padding: "10px",
                                            cursor: "pointer",
                                            borderBottom: "1px solid #eee",
                                            backgroundColor: selectedCustomer?.id === customer.id ? "#f0f0f0" : "white",
                                        }}
                                        onMouseOver={(e) => e.currentTarget.style.backgroundColor = "#f0f0f0"}
                                        onMouseOut={(e) => e.currentTarget.style.backgroundColor = selectedCustomer?.id === customer.id ? "#f0f0f0" : "white"}
                                    >
                                        {customer.email} ({customer.name})
                                    </div>
                                ))}
                            </div>
                        ) : (
                            error !== '' &&
                            <div style={{
                                position: "absolute",
                                left: "4%",
                                width: "92%",
                                backgroundColor: "white",
                                border: "1px solid #ccc",
                                borderRadius: "6px",
                                maxHeight: "200px",
                                overflowY: "auto",
                                zIndex: 1000,
                                marginTop: "5px"
                            }}>
                                <div
                                    style={{
                                        padding: "10px",
                                        cursor: "pointer",
                                        borderBottom: "1px solid #eee",
                                        textAlign: "center"
                                    }}
                                >
                                    {error}
                                </div>

                            </div>)}
                        {selectedCustomer && (
                            <select name="saas_plan" id="saas_plan" style={{
                                width: "100%",
                                height: '40px',
                                borderRadius: "6px",
                                border: "1px solid #ccc",
                                textIndent: "10px",
                                marginTop: "10px",
                            }}
                                value={selectedPlan}
                                onChange={(e) => setSelectedPlan(e.target.value)}>
                                {agencySaas?.map((item, index) => (
                                    <option value={item?._id} key={index}>{item?.product_name}</option>
                                ))}
                            </select>
                        )}
                        <div style={{ margin: "10px 0px" }}>
                            <button className='savebtn-setting w-100' onClick={handleEnableSaas}>Enable SaaS</button>
                        </div>
                    </div>
                </div>
            )} */}
            {/* {opensaasModaloff && (
                <div className="modal-zz-confirm text-left">
                    <div className="scrollable-modal-content bg-white rounded" style={{ position: "relative" }}>
                        <span className='crossison' onClick={() => setopensaasModaloff(false)}>X</span>
                        <div style={{ position: 'relative' }}>
                            <p style={{ textAlign: "center" }}>Are you Sure You Want to disable SaaS</p>
                        </div>

                        <div style={{ margin: "10px 0px" }}>
                            <button className='savebtn-setting w-100' onClick={handleupdateaccount_tyoe_to_Free}>Disable SaaS</button>
                        </div>
                    </div>
                </div>
            )} */}
        </div>
    );
}

export default SaasTab;